import {
  Box,
  Button,
  Input,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Td,
  Text,
  WrapItem,
} from "@chakra-ui/react";
import React, { useCallback, useEffect } from "react";
import CustomDataModal from "../../../components/UI/CustomDataModal";
import CustomInput from "../../../components/UI/CustomInput";
import CustomSelect from "../../../components/UI/CustomSelect";
import CustomTable from "../../../components/UI/Table";
import {
  getClientBetsCricketAPI,
  handleBetAPI,
} from "../../../service/cricket";

export default function ViewMoreBet({
  isOpen,
  onClose,
  gameType,
  eventId,
  data,
}) {
  const [columns, setColumns] = React.useState([
    { name: "UserName", id: "userName" },
    { name: "Nation", id: "runnerName" },
    { name: "Bet Type", id: "marketName" },
    { name: "Amount", id: "amount" },
    { name: "User Rate", id: "rate" },
    {
      name: "Place Date",
      id: "userName",
      element: (row) => (
        <Td>
          <Text>{new Date(row?.placeDate).toLocaleString()}</Text>
        </Td>
      ),
    },

    { name: "IP", id: "ipAddress" },
    {
      name: "Match Date",
      id: "userName",
      element: (row) => (
        <Td>
          <Text>{new Date(row?.placeDate).toLocaleString()}</Text>
        </Td>
      ),
    },
    {
      name: "Browser Details",
      id: "browserDetails",
      element: (row) => (
        <Td>
          <Popover preventOverflow={true}>
            <PopoverTrigger>
              <Text _hover={{ cursor: "pointer" }} color="blue.500">
                Show
              </Text>
            </PopoverTrigger>
            <PopoverContent>{row?.browserDetails}</PopoverContent>
          </Popover>
        </Td>
      ),
    },
    {
      name: "Action",
      id: "action",
      element: (row) => (
        <Td>
          <Button
            onClick={() => handleBet(row, "DELETED")}
            mr="1"
            colorScheme="red"
            size="xs"
            fontSize={{ base: "10px", md: "xs" }}
          >
            Delete
          </Button>
          <Button
            onClick={() => handleBet(row, "UNMATCHED")}
            colorScheme="blue"
            size="xs"
            fontSize={{ base: "10px", md: "xs" }}
          >
            Un-Match
          </Button>
        </Td>
      ),
    },
  ]);
  const [rows, setRows] = React.useState([]);
  const [betStatus, setBetStatus] = React.useState("MATCHED");
  const [clientName, setClientName] = React.useState("");
  const [ipAddress, setIpAddress] = React.useState("");
  const [betAmount, setBetAmount] = React.useState("");
  const [betType, setBetType] = React.useState("");

  const getClientBets = useCallback(
    async (betStatus_) => {
      setRows([]);
      const { response } = await getClientBetsCricketAPI(
        eventId,
        betStatus_ ? betStatus_ : betStatus
      );
      console.log(response, "response");
      if (response) {
        setRows(response);
      }
    },
    [betStatus, eventId]
  );
  const handleBet = async (data, action = "DELETED") => {
    const { response, code } = await handleBetAPI(data.id, action);
    if (code === 200) {
      getClientBets();
    }
  };
  const search = () => {
    let rows_ = rows;
    if (clientName) {
      rows_ = rows_.filter((row) => row.userName.includes(clientName));
    }
    if (ipAddress) {
      rows_ = rows_.filter((row) => row.ipAddress.includes(ipAddress));
    }
    if (betAmount) {
      rows_ = rows_.filter((row) => row.amount === betAmount);
    }
    if (betType) {
      rows_ = rows_.filter((row) => row.betType.includes(betType));
    }
    setRows(rows_);
  };
  useEffect(() => {
    if (eventId) {
      getClientBets();
    }
  }, [betStatus, eventId, getClientBets]);

  return (
    <CustomDataModal
      size="7xl"
      header={"View More Bet"}
      onClose={onClose}
      isOpen={isOpen}
    >
      <Tabs size={{ base: "sm", md: "md" }}>
        <TabList flexWrap="wrap">
          <Tab
            fontSize={{ base: "12px", md: "sm" }}
            px={{ base: 2, md: 4 }}
            onClick={() => {
              setBetStatus("MATCHED");
              getClientBets("MATCHED");
              setRows([]);
            }}
          >
            Matched Bets
          </Tab>
          <Tab
            fontSize={{ base: "12px", md: "sm" }}
            px={{ base: 2, md: 4 }}
            onClick={() => {
              setBetStatus("UNMATCHED");
              getClientBets("UNMATCHED");
              setRows([]);
            }}
          >
            Unmatched Bets
          </Tab>
          <Tab
            fontSize={{ base: "12px", md: "sm" }}
            px={{ base: 2, md: 4 }}
            onClick={() => {
              setBetStatus("DELETED");
              getClientBets("DELETED");
              setRows([]);
            }}
          >
            Deleted Bets
          </Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <Box>
              <Box
                display="flex"
                flexWrap="wrap"
                gap="2"
                mb="2"
                alignItems="flex-end"
              >
                <Box flex={{ base: "1 1 100%", sm: "1 1 calc(50% - 8px)", md: "1" }}>
                  <CustomInput
                    onChange={(e) => {
                      setClientName(e.target.value);
                    }}
                    label="Client"
                    placeholder="All Client"
                  />
                </Box>
                <Box flex={{ base: "1 1 100%", sm: "1 1 calc(50% - 8px)", md: "1" }}>
                  <CustomInput
                    onChange={(e) => {
                      setIpAddress(e.target.value);
                    }}
                    label="IP Address"
                  />
                </Box>
                <Box flex={{ base: "1 1 100%", sm: "1 1 calc(50% - 8px)", md: "1" }}>
                  <CustomInput
                    onChange={(e) => {
                      setBetAmount(e.target.value);
                    }}
                    label="Bet Amount"
                  />
                </Box>
                <Box flex={{ base: "1 1 100%", sm: "1 1 calc(50% - 8px)", md: "1" }}>
                  <CustomSelect
                    m="1"
                    label="Type"
                    onChange={(e) => {
                      setBetType(e.target.value);
                    }}
                    options={[
                      { label: "All", value: "" },
                      { label: "Back", value: "back" },
                      { label: "Lay", value: "lay" },
                    ]}
                  />
                </Box>
                <Box flex={{ base: "1 1 100%", md: "0 0 auto" }}>
                  <Button onClick={search} width={{ base: "100%", md: "auto" }}>Search</Button>
                </Box>
              </Box>
            </Box>
            <CustomTable columns={columns} rows={rows} />
          </TabPanel>
          <TabPanel>
            <CustomTable columns={columns} rows={rows} />
          </TabPanel>
          <TabPanel>
            <CustomTable columns={columns} rows={rows} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </CustomDataModal>
  );
}
